const AI_FEATURE_USER_IDS = (process.env.REACT_APP_AI_FEATURE_USER_IDS || '')
  .split(',')
  .map((id) => id.trim())
  .filter(Boolean);

const AI_FEATURE_SCHOOL_IDS = (process.env.REACT_APP_AI_FEATURE_SCHOOL_IDS || '')
  .split(',')
  .map((id) => id.trim())
  .filter(Boolean);

/**
 * Lấy tất cả school_id của user từ user.schools[].
 * @param {Object} user
 * @returns {string[]}
 */
const getUserSchoolIds = (user) => {
  if (!Array.isArray(user.schools)) return [];
  return user.schools
    .map((s) => s.school_id)
    .filter(Boolean)
    .map(String);
};

/**
 * Check if a user has access to AI features based on the whitelist env var.
 * @param {Object} user - User object from Redux auth state
 * @returns {boolean}
 */
export const hasAiFeatureAccess = (user) => {
  if (!user || !user.id) return false;
  return AI_FEATURE_USER_IDS.includes(String(user.id));
};

/**
 * Check if a user has access to AI features based on their school(s).
 * Trả về true nếu bất kỳ trường nào của user nằm trong whitelist.
 * @param {Object} user - User object from Redux auth state
 * @returns {boolean}
 */
export const hasAiFeatureAccessBySchool = (user) => {
  if (AI_FEATURE_SCHOOL_IDS.length === 0) return true;
  if (!user || !user.id) return false;
  return getUserSchoolIds(user).some((id) =>
    AI_FEATURE_SCHOOL_IDS.includes(id)
  );
};
